import {
  col,
  col1,
  col10,
  col11,
  col12,
  col2,
  col3,
  col4,
  col5,
  col6,
  col7,
  col8,
  col9,
  colAuto,
  colLg,
  colLg1,
  colLg10,
  colLg11,
  colLg12,
  colLg2,
  colLg3,
  colLg4,
  colLg5,
  colLg6,
  colLg7,
  colLg8,
  colLg9,
  colLgAuto,
  colMd,
  colMd1,
  colMd10,
  colMd11,
  colMd12,
  colMd2,
  colMd3,
  colMd4,
  colMd5,
  colMd6,
  colMd7,
  colMd8,
  colMd9,
  colMdAuto,
  colSm,
  colSm1,
  colSm10,
  colSm11,
  colSm12,
  colSm2,
  colSm3,
  colSm4,
  colSm5,
  colSm6,
  colSm7,
  colSm8,
  colSm9,
  colSmAuto,
  colXl,
  colXl1,
  colXl10,
  colXl11,
  colXl12,
  colXl2,
  colXl3,
  colXl4,
  colXl5,
  colXl6,
  colXl7,
  colXl8,
  colXl9,
  colXlAuto,
  offset1,
  offset10,
  offset11,
  offset2,
  offset3,
  offset4,
  offset5,
  offset6,
  offset7,
  offset8,
  offset9,
  offsetXl1,
  offsetXl10,
  offsetXl11,
  offsetXl2,
  offsetXl3,
  offsetXl4,
  offsetXl5,
  offsetXl6,
  offsetXl7,
  offsetXl8,
  offsetXl9,
  offsetSm1,
  offsetSm10,
  offsetSm11,
  offsetSm2,
  offsetSm3,
  offsetSm4,
  offsetSm5,
  offsetSm6,
  offsetSm7,
  offsetSm8,
  offsetSm9,
  offsetMd1,
  offsetMd10,
  offsetMd11,
  offsetMd2,
  offsetMd3,
  offsetMd4,
  offsetMd5,
  offsetMd6,
  offsetMd7,
  offsetMd8,
  offsetMd9,
  offsetLg1,
  offsetLg10,
  offsetLg11,
  offsetLg2,
  offsetLg3,
  offsetLg4,
  offsetLg5,
  offsetLg6,
  offsetLg7,
  offsetLg8,
  offsetLg9,
  order0,
  order1,
  order10,
  order11,
  order12,
  order2,
  order3,
  order4,
  order5,
  order6,
  order7,
  order8,
  order9,
} from '@farvisionllc/emotion-bootstrap';

export const colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];

const colX = [
  col,
  col1,
  col2,
  col3,
  col4,
  col5,
  col6,
  col7,
  col8,
  col9,
  col10,
  col11,
  col12,
];

const colSmX = [
  colSm,
  colSm1,
  colSm2,
  colSm3,
  colSm4,
  colSm5,
  colSm6,
  colSm7,
  colSm8,
  colSm9,
  colSm10,
  colSm11,
  colSm12,
];

const colMdX = [
  colMd,
  colMd1,
  colMd2,
  colMd3,
  colMd4,
  colMd5,
  colMd6,
  colMd7,
  colMd8,
  colMd9,
  colMd10,
  colMd11,
  colMd12,
];

const colLgX = [
  colLg,
  colLg1,
  colLg2,
  colLg3,
  colLg4,
  colLg5,
  colLg6,
  colLg7,
  colLg8,
  colLg9,
  colLg10,
  colLg11,
  colLg12,
];

const colXlX = [
  colXl,
  colXl1,
  colXl2,
  colXl3,
  colXl4,
  colXl5,
  colXl6,
  colXl7,
  colXl8,
  colXl9,
  colXl10,
  colXl11,
  colXl12,
];

const orderX = [
  order0,
  order1,
  order2,
  order3,
  order4,
  order5,
  order6,
  order7,
  order8,
  order9,
  order10,
  order11,
  order12,
];

const offsetX = [
  undefined,
  offset1,
  offset2,
  offset3,
  offset4,
  offset5,
  offset6,
  offset7,
  offset8,
  offset9,
  offset10,
  offset11,
];

const offsetLg = [
  undefined,
  offsetLg1,
  offsetLg2,
  offsetLg3,
  offsetLg4,
  offsetLg5,
  offsetLg6,
  offsetLg7,
  offsetLg8,
  offsetLg9,
  offsetLg10,
  offsetLg11,
];

const offsetSm = [
  undefined,
  offsetSm1,
  offsetSm2,
  offsetSm3,
  offsetSm4,
  offsetSm5,
  offsetSm6,
  offsetSm7,
  offsetSm8,
  offsetSm9,
  offsetSm10,
  offsetSm11,
];

const offsetMd = [
  undefined,
  offsetMd1,
  offsetMd2,
  offsetMd3,
  offsetMd4,
  offsetMd5,
  offsetMd6,
  offsetMd7,
  offsetMd8,
  offsetMd9,
  offsetMd10,
  offsetMd11,
];

const offsetXl = [
  undefined,
  offsetXl1,
  offsetXl2,
  offsetXl3,
  offsetXl4,
  offsetXl5,
  offsetXl6,
  offsetXl7,
  offsetXl8,
  offsetXl9,
  offsetXl10,
  offsetXl11,
];

export const widthMap = {
  xs: {
    auto: colAuto,
    cols: colX,
    offsets: offsetX,
    orders: orderX,
  },
  sm: {
    auto: colSmAuto,
    offsets: offsetSm,
    orders: orderX,
    cols: colSmX,
  },
  md: {
    auto: colMdAuto,
    offsets: offsetMd,
    orders: orderX,
    cols: colMdX,
  },
  lg: {
    auto: colLgAuto,
    offsets: offsetLg,
    orders: orderX,
    cols: colLgX,
  },
  xl: {
    auto: colXlAuto,
    offsets: offsetXl,
    orders: orderX,
    cols: colXlX,
  },
};

export const getColumnSizeClass = (name, colWidth, colSize) => {
  if (colSize === true || colSize === '') {
    return widthMap[colWidth][name][0];
  }
  if (colSize === 'auto') {
    return widthMap[colWidth].auto;
  }
  return widthMap[colWidth][name][colSize];
};
